import { IExternalScriptConfig, IScriptSnippet } from '../types/ExternalScript';

export const isIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

type ScriptConfig = string | IScriptSnippet;

const loadScript = (scriptItem: ScriptConfig, location: 'head' | 'body') => {
  return new Promise((resolve, reject) => {
    try {
      const scriptTag = document.createElement('script');
      let scriptLink: string;
      let async = true;
      if (typeof scriptItem === 'string') {
        scriptLink = scriptItem;
      } else {
        scriptLink = scriptItem.snippet;
        if (typeof scriptItem.async === 'boolean') async = scriptItem.async;
      }
      scriptTag.src = scriptLink;
      if (async) scriptTag.async = true;
      if (location === 'head') {
        document.head.appendChild(scriptTag);
      } else {
        document.body.appendChild(scriptTag);
      }
      console.log(
        `loading this script in ${location} (async: ${async})`,
        scriptLink
      );
      scriptTag.onload = () => {
        resolve(`Script Loaded Successfully: ${scriptLink}`);
      };
      scriptTag.onerror = () => {
        reject(new Error(`Error in Loading Script: ${scriptLink}`));
      };
    } catch (e) {
      reject(e);
    }
  });
};

export const loadAllExternalScripts = (scripts: IExternalScriptConfig) => {
  const inIframe = isIframe();

  const filterScripts = (items: (IScriptSnippet | string)[]) => {
    return items.filter((item) => {
      if (typeof item === 'string') return true;
      return inIframe ? item.iframe : item.standalone;
    });
  };

  const getSnippet = (item: IScriptSnippet | string) => {
    return typeof item === 'string' ? item : item.snippet;
  };

  const headLinks = filterScripts(scripts.head?.links || []);
  const headSnippets = filterScripts(scripts.head?.snippets || []);
  const bodyLinks = filterScripts(scripts.body?.links || []);
  const bodySnippets = filterScripts(scripts.body?.snippets || []);

  const headPromises = headLinks.map((item) => loadScript(item, 'head'));
  const bodyPromises = bodyLinks.map((item) => loadScript(item, 'body'));

  headSnippets.forEach((item) => {
    document.head.insertAdjacentHTML(
      'beforeend',
      getSnippet(item).replace(/\n/g, ' ')
    );
  });

  bodySnippets.forEach((item) => {
    document.body.insertAdjacentHTML(
      'beforeend',
      getSnippet(item).replace(/\n/g, ' ')
    );
  });

  return Promise.all([...headPromises, ...bodyPromises]);
};
